import L from 'leaflet';
import Popup from '../popup/popup';

export default class Line extends L.Polyline {
    constructor(map, data, fnSelectZone) {
        super(data.dataForMap.points, {
            color: data.dataForMap.color,
            weight: 3,
        });
        this.map = map;
        this.points = data.dataForMap.points;
        this.type = data.type;
        this.color = data.dataForMap.color;
        this.icon = data.dataForMap.icon;
        this.name = data.name;
        this.radius = data.dataForMap.radius;
        this.id = data.id;
        this.data = data;
        this.fnSelectZone = fnSelectZone;

        this.tooltip;
        this.permanentTooltipOpened = false;
        document.addEventListener('map:toggleGeofenceTooltipVisibility', e => {
            try {
                this.toggleTooltipVisibility();
            }
            catch (error) {
                console.error(error);
            }
        });

        this.addTooltip({ permanent: false });

        this.on('click', this.onClick);
        this.on('mouseover', (e) => this.onOverLine(e));
        this.on('mouseout', (e) => this.onOutLine(e));
        this.map.on('zoomstart', (e) => {
            this.setStyle({ weight: 3, opacity: 1 });
        });

        this.map.on('zoomend', (e) => {
            try {
                this.toggleTooltipVisibility();
            }
            catch (error) {
                console.error(error);
            }
        });

        this.map.on('moveend', (e) => {
            try {
                this.toggleTooltipVisibility();
            }
            catch (error) {
                console.error(error);
            }
        });
    }

    getCoords() {
        let latLngs = this.getLatLngs().map(item => {
            return {
                lat: item.lat,
                lon: item.lng
            }
        });
        return latLngs;
    }

    onClick(e) {
        if (this.map.isAllClicksBlocked()) {
            return;
        }

        this.fnSelectZone(this.id)
            .then(data => {
                this.popup = new Popup(this.map, this.name, data.params, e.latlng);
                this.popup.show();
            });
    }

    onOverLine() {
        const weight = this.getLineWidth(this.radius);
        this.setStyle({ weight: weight, opacity: 0.3 });
        if (!this.permanentTooltipOpened) {
            this.openTooltip();
        }
    }

    onOutLine() {
        this.setStyle({ weight: 3, opacity: 1 });
        if (!this.permanentTooltipOpened) {
            this.closeTooltip();
        }
    }

    getLineWidth(radiusInMeters) {
        let pointC = this.map.latLngToContainerPoint(this.map.getCenter());
        let pointX = [pointC.x + 1, pointC.y]; //add one pixel to x
        let latLngC = this.map.containerPointToLatLng(pointC);
        let latLngX = this.map.containerPointToLatLng(pointX);
        let distanceX = latLngC.distanceTo(latLngX); // calculate distance between c and x (latitude) - столько метров в 1 пикселе
        let wght = radiusInMeters / distanceX; //ширина полилинии в пикселях на текущем масштабе карты
        if (wght < 3)
            wght = 3;
        return wght;
    }

    toggleTooltipVisibility() {
        const options = this.map.options.geofenceTooltip;
        if (
            options.isAlwaysVisible
            && !this.permanentTooltipOpened
            && this.map.getZoom() >= options.minVisibleZoom
            && this.map.getBounds().contains(this.getBounds().getCenter())
        ) {
            this.permanentTooltipOpened = true;
            this.addTooltip({ permanent: true });
            this.openTooltip(this, this.getBounds().getCenter());
        }
        else if (
            this.permanentTooltipOpened && !options.isAlwaysVisible
            || this.permanentTooltipOpened && this.map.getZoom() < options.minVisibleZoom
        ) {
            this.permanentTooltipOpened = false;
            this.addTooltip({ permanent: false });
        }
    }

    addTooltip(options) {
        if (this.tooltip) {
            this.unbindTooltip(this.tooltip);
        }
        this.tooltip = L.tooltip({
            permanent: options.permanent,
            interactive: false,
            direction: 'bottom',
            offset: new L.Point(0, 0)
        });
        this.tooltip.setContent(this.name);
        this.tooltip.on('click', (e) => { this._onClick(e) });
        this.bindTooltip(this.tooltip);
    }
}
